<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <category-list type="directives"  />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'TopLevelDirectives',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/top-level-directives.vue